import React from 'react'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import Header from '_components/header'
import { BATCH_PREBUILT_ATTRIBUTES_ENDPOINT } from '_services/batch-prebuillt-attributes'
import ListView from '_components/list-view'
import { gateEnvOptions } from '_lib/env'

// Production is only available in production builds; gated out otherwise.
export const ENV_OPTIONS = gateEnvOptions([
  { label: 'Production', value: 'prod' },
  { label: 'Development', value: 'dev' },
])

const BatchPrebuiltAttributeProcesses = () => {
  const handleNewBatch = () => {
    window._history.push(`/batch-prebuilt-attributes/setup`)
  }
  return (
    <div>
      <Header
        title="Batch Prebuilt Attribute – Processes"
        actions={[
          {
            children: 'Create Batch',
            onClick: handleNewBatch,
          },
        ]}
      />
      <ListView
        columns={[
          {
            name: 'Name',
            key: 'name',
            render: (item) => (
              <div>
                <Link to={`/batch-prebuilt-attributes/process/${item._id}`}>{item.name}</Link>
              </div>
            ),
            width: 500,
            sortable: true,
          },
          {
            name: 'Approval Process Status',
            key: 'approval_process',
          },
          {
            key: 'created_at',
            name: 'Created At',
            render: (item) => dayjs(item.created_at).format('MM/DD/YYYY HH:mm'),
            sortable: true,
          },
          {
            key: 'created_by.email',
            name: 'Created By',
          },
        ]}
        filters={[{ label: 'Environment', name: 'env', options: ENV_OPTIONS }]}
        filter_on_load={{ env: ENV_OPTIONS[0] }}
        entities={BATCH_PREBUILT_ATTRIBUTES_ENDPOINT}
        searchable={true}
        sort_dir={-1}
        sort_key={'created_at'}
      />
    </div>
  )
}

export default BatchPrebuiltAttributeProcesses
